import { Injectable } from '@angular/core';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isAuth: BehaviorSubject<any>;
  photo: BehaviorSubject<any>;
  isExamStarted: BehaviorSubject<any>;
  pass_key: BehaviorSubject<any>;

  constructor() {
    this.isAuth = new BehaviorSubject('');
    this.photo = new BehaviorSubject('');
    this.isExamStarted = new BehaviorSubject('');
    this.pass_key = new BehaviorSubject('')
    if (localStorage.getItem('token')) {
      this.isAuth.next(true);
      const profilePhoto = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))['profilePhoto'] || localStorage.getItem('profileImageUrl');
      this.photo.next(profilePhoto)
    } else {
      this.isAuth.next(false);
      this.photo.next(null)
    }
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    return token ? true : false;
  }

  updateAuthStatus(status: boolean): void {
    this.isAuth.next(status);
  }

  getPhoto(): Observable<string> {
    return this.photo.asObservable();
}

setPhoto(user: any) {
    this.photo.next(user);
}

getIsExamStarted(): Observable<string> {
  return this.isExamStarted.asObservable();
}

setIsExamStarted(value: any) {
  this.isExamStarted.next(value);
}

getPasskey(): Observable<string> {
  return this.pass_key.asObservable();
}

setPasskey(value: any) {
  this.pass_key.next(value);
}
}
